import PropTypes from 'prop-types';

import AvatarIcon from 'components/AvatarIcon';
import proNotifications from 'modules/proNotifications';
import ModalManager from 'modules/modalManager';
import ClientMessageModal from 'components/provider/modals/ClientMessageModal';

import './Notification.scss';

/**
 * Client message notification
 */
export default function ClientMessage(props) {
  const { notification } = props;

  /**
   * Open the message modal
   */
  const openModal = () => {
    ModalManager.openModal(ClientMessageModal, {
      message: notification,
    });
    proNotifications.trackNotificationClick(notification);
  };

  return (
    <button
      onClick={openModal}
      className="button-notification"
    >
      <section className="notification">
        <div className="icon">
          <AvatarIcon
            icon={notification.thumbnail}
            name={notification.client_name}
          />
        </div>
        <section className="notification-body">
          <p className="notification-text short-text">
            <strong>
              {notification.client_name}
            </strong>
            <span>
              {` "${notification.message}" `}
            </span>
          </p>
          <span className="from-now">{proNotifications.getFromNowDisplay(notification.creation_time)}</span>
        </section>
      </section>
    </button>
  );
}

ClientMessage.propTypes = {
  /** @type {Object} Notification object */
  notification: PropTypes.object.isRequired,
};
